import { getUserInfo, getUserPhone, getUserInMallStatus } from '../api/user'
import Vue from 'vue'
import store from '../store'
/**
 * 进入页面时，验证用户是否登录
 */
function auth () {
  return new Promise((resolve, reject) => {
    getUserInfo(true)
      .then(res => {
        const userInfo = res.data.obj || {}
        if (userInfo.id && !userInfo.phone) {
          getUserPhone(userInfo.id).then(phoneRes => {
            const userPhone = phoneRes.data && phoneRes.data.map && phoneRes.data.map.phone
            userInfo.phone = userPhone
            store.commit('user/setUserInfo', { userInfo })
            resolve(res.data)
          }).catch(() => {
            store.commit('user/setUserInfo', { userInfo })
            resolve(res.data)
          })
        } else {
          store.commit('user/setUserInfo', { userInfo })
          resolve(res.data)
        }
      })
      .catch(err => {
        err && console.warn(err)
        // eslint-disable-next-line
        reject()
      })
  })
}

function status () {
  return new Promise((resolve, reject) => {
    getUserInMallStatus()
      .then(res => {
        store.commit('user/setUserInMallStatus', { userInMallStatus: res.data.map || {} })
        resolve(res.data)
      })
      .catch(err => {
        err && console.warn(err)
        // eslint-disable-next-line
        reject()
      })
  })
}

function install () {
  Vue.user = Vue.prototype.user = {
    auth,
    status
  }
}

Vue.use(install)

export default install
